import moment from "moment-timezone";

export class DeviceUtils {
  static getActivityClassName (lastOnlineTime: string) {
    if (!lastOnlineTime) return "activity-icon activity-icon--red";

    const minutesDiff = Math.abs(moment().diff(moment(lastOnlineTime), "minutes", true));

    if (minutesDiff < 1) return "activity-icon activity-icon--green";
    if (minutesDiff < 3) return "activity-icon activity-icon--dark-green";
    if (minutesDiff < 7) return "activity-icon activity-icon--yellow";
    if (minutesDiff < 10) return "activity-icon activity-icon--orange";

    return "activity-icon activity-icon--red";
  };
}
